module.exports = __webpack_public_path__ + "img/crib-club-logo-centered.945ddb37.png";